import { priceResponseSchema } from "../schemas/price.schema";

export function parsePriceResponse(data: unknown) {
    const result = priceResponseSchema.safeParse(data);
    if (!result.success) return null;
    return result.data.getTotalPriceSunProtection;
}
